import type { UserProfileFeatureConfig } from './type';

export const userProfile: UserProfileFeatureConfig = {
    displayDisabledSelfEmployedStatus: false,
    fetchEmployers: false,
    numberOfChildrenOptional: true,
    showNumberOfChildren: true,
    taxInfo: {
        isLastTaxInfoDeletable: true,
    },
};
